module.exports = __webpack_public_path__ + "img/silver_popolvuh.bb63f9cf.jpg";